// Submit LOGIN to the Lobby Page //

document.getElementById("login-form").addEventListener("submit", function (e) {
  e.preventDefault(); // Stop form from submitting normally
  // Optionally validate form or perform AJAX login here
  window.location.href = "lobby.html"; // Redirect to lobby.html
});


// LOGIN Validation process //

const form = document.getElementById("login-form");
const usernameInput = document.getElementById("username");
const passwordInput = document.getElementById("password");
const usernameGroup = document.getElementById("username-group");
const passwordGroup = document.getElementById("password-group");
const loginBtn = document.querySelector(".login-btn");

// Email validation regex
const emailRegex = /^[^\s@]+@[^\s@]+\.com$/;

// Password validation regex
const passwordRegex = /^[A-Z](?=.*\d)/;

// Validate username (email)
usernameInput.addEventListener("input", function () {
  const isValidEmail = emailRegex.test(this.value);

  if (isValidEmail) {
    usernameGroup.classList.remove("error");
  } else {
    usernameGroup.classList.add("error");
  }

  validateForm();
});

// Validate password
passwordInput.addEventListener("input", function () {
  const isValidPassword = passwordRegex.test(this.value);

  if (isValidPassword) {
    passwordGroup.classList.remove("error");
  } else {
    passwordGroup.classList.add("error");
  }

  validateForm();
});

// Form validation function
function validateForm() {
  const isValidEmail = emailRegex.test(usernameInput.value);
  const isValidPassword = passwordRegex.test(passwordInput.value);

  if (isValidEmail && isValidPassword) {
    loginBtn.disabled = false;
  } else {
    loginBtn.disabled = true;
  }
}

// Prevent form submission and show an alert (you'd replace this with actual login logic)
form.addEventListener("submit", function (e) {
  e.preventDefault();
  alert("Login successful!");
});


// SIGNUP page //

 const form_signup = document.getElementById("signup-form");
 const firstName = document.getElementById("first-name");
 const lastName = document.getElementById("last-name");
 const email = document.getElementById("email");
 const password = document.getElementById("password");
 const confirmPassword = document.getElementById("confirm-password");
 const signupBtn = document.querySelector(".signup-btn");

 // Email validation regex
 const emailRegex_signup = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

 // Password validation regex
 const passwordRegex_signup = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{8,})/;

 // Validation function
 function validateForm() {
   const isValidFirstName = firstName.value.trim() !== "";
   const isValidLastName = lastName.value.trim() !== "";
   const isValidEmail = emailRegex.test(email.value);
   const isValidPassword = passwordRegex.test(password.value);
   const isPasswordConfirmed = password.value === confirmPassword.value;

   if (
     isValidFirstName &&
     isValidLastName &&
     isValidEmail &&
     isValidPassword &&
     isPasswordConfirmed
   ) {
     signupBtn.disabled = false;
   } else {
     signupBtn.disabled = true;
   }
 }

 // Add event listeners for real-time validation
 firstName.addEventListener("input", validateForm);
 lastName.addEventListener("input", validateForm);
 email.addEventListener("input", validateForm);
 password.addEventListener("input", validateForm);
 confirmPassword.addEventListener("input", validateForm);

 // Form submission handler
 form.addEventListener("submit", function (e) {
   e.preventDefault();

   // Here you would typically send the data to a server
   alert("Sign Up Successful!");
 });